import { render } from "./Recetas.vue?vue&type=template&id=8876ac7e&ts=true"
import script from "./Recetas.vue?vue&type=script&lang=ts"
export * from "./Recetas.vue?vue&type=script&lang=ts"

import "./Recetas.vue?vue&type=style&index=0&id=8876ac7e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__